import { RefObject, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import GymAccessCategoryMappingTemplate from '../../templates/GymAccessCategoryMapping/GymAccessCategoryMappingTemplate';
import { useAppDispatch, useAppSelector } from '@gym-redux/store';
import { GymAccessCategoryType } from '../../../particles/types/AccessCategoryMapping';
import Loader from '@gym-atoms/Loader/Loader';
import { fetchAccessCategories } from '../../../redux/slices/accessCategorySlice';
import dayjs from 'dayjs';

interface chainIdType {
  chainId: string;
}

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const dispatch = useAppDispatch();
  const { gymAccessCategoryId, gymId, chainId } = useParams<{
    gymAccessCategoryId: string;
    gymId: string;
    chainId: string;
  }>();
  console.log(gymAccessCategoryId, gymId, chainId);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      fetchAccessCategories({
        siteLocationId: +gymId
      })
    );
  }, []);

  const [gymAccessCategoryState, setGymAccessCategoryState] = useState<GymAccessCategoryType>();
  const gymAccessCategory = useAppSelector((state) =>
    state.accessCategory.items
      .find((g) => g.siteLocationId === +gymId)
      ?.items.find((g) => g.siteLocationAccessCategoryId === +gymAccessCategoryId)
  );
  console.log({ gymAccessCategory });
  const createGymAccessCategory = async () => {
    const items = {
      id: gymAccessCategory?.id || 0,
      siteId: gymAccessCategory?.siteId || 0,
      name: gymAccessCategory?.name || '',
      gender: gymAccessCategory?.gender || '',
      age: gymAccessCategory?.age || 0,
      schedulesOnly: gymAccessCategory?.schedulesOnly ? 'true' : 'false',
      status: gymAccessCategory?.status || '',
      siteLocationAccessCategoryId: gymAccessCategory?.siteLocationAccessCategoryId || 0,
      siteLocationId: gymAccessCategory?.siteLocationId || 0,
      siteLocationMembershipId: gymAccessCategory?.siteLocationMembershipId || 0,
      accessCategoryId: gymAccessCategory?.accessCategoryId || 0,
      locationName: gymAccessCategory?.locationName || '',
      arxAccessCategoryId: gymAccessCategory?.arxAccessCategoryId || '',
      importedId: gymAccessCategory?.importedId || '',
      membershipName: gymAccessCategory?.membershipName || '',
      program: gymAccessCategory?.program || '',
      scheduleType: gymAccessCategory?.scheduleType || '',
      createdDate: gymAccessCategory?.createdDate
        ? dayjs(gymAccessCategory?.createdDate || '').format('DD MMM YYYY')
        : '',
      createdBy: gymAccessCategory?.createdBy || 0,
      lastModifiedBy: gymAccessCategory?.lastModifiedBy || 0,
      lastModifiedDate: gymAccessCategory?.lastModifiedDate || ''
    };
    console.log({ items });

    setGymAccessCategoryState(items);
  };

  useEffect(() => {
    createGymAccessCategory();
  }, []);

  if (gymAccessCategoryState) {
    return (
      <Card className="p-card-w-table">
        <GymAccessCategoryMappingTemplate
          type="modify"
          heading={t('MODIFY_ACCESS_CATEGORY.PAGE_TITLE')}
          accessCategoryMapping={gymAccessCategoryState}
        />
      </Card>
    );
  } else {
    return (
      <Card className="pt30 pl40 pr40 pb30">
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
      </Card>
    );
  }
};

const ModifyGymAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId, gymId } = useParams<{ chainId: string; gymId: string }>();

  return (
    <TwoColTemplate
      title={t('MODIFY_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(`/gymChains/${chainId}/gymChainAccessCategories`)}
    />
  );
};

export default ModifyGymAccessCategoryPage;
